import Component from '@glimmer/component';
import { service } from '@ember/service';

export default class BatchReport extends Component {
  @service strings;
}
